interface PaymentPlatform {
  platform?: string;
}

/**
 * Whether an organisation's payment platforms include a Stripe connection.
 * The same rule the Stripe panel on the finance tab uses for its connected
 * state, so the two never disagree.
 */
export const isStripeConnected = (paymentPlatforms: unknown): boolean =>
  Array.isArray(paymentPlatforms) &&
  paymentPlatforms.some(
    (item: PaymentPlatform | null) => item?.platform === 'stripe'
  );
